const components = {
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
  MuiLink: {
    defaultProps: {
      underline: "hover",
    },
  },
  MuiCardHeader: {
    defaultProps: {
      titleTypographyProps: {
        variant: "h6",
      },
    },
    styleOverrides: {
      action: {
        marginTop: "-4px",
        marginRight: "-4px",
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: "6px",
        fontWeight: 500,
        fontSize: "0.8125rem",
        padding: "6px 16px",
        textTransform: "none",
      },
      containedPrimary: {
        backgroundColor: "#1a3a5c",
        "&:hover": {
          backgroundColor: "#2196f3",
        },
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        backgroundImage: "none",
      },
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: "20px 24px",
        "&:last-child": {
          paddingBottom: "20px",
        },
      },
    },
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        "& .MuiTableCell-head": {
          backgroundColor: "#f8f9fa",
          color: "#1a3a5c",
          fontWeight: 600,
          fontSize: "0.75rem",
          letterSpacing: "0.04em",
          textTransform: "uppercase",
          borderBottom: "1px solid #e9ecef",
          padding: "12px 16px",
        },
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        padding: "12px 16px",
        borderBottom: "1px solid rgba(0,0,0,0.06)",
      },
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        "&:hover": {
          backgroundColor: "rgba(26, 58, 92, 0.04)",
        },
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: "none",
      },
    },
  },
  MuiPickersDay: {
    styleOverrides: {
      day: {
        fontWeight: "300",
      },
    },
  },
  MuiPickersYear: {
    styleOverrides: {
      root: {
        height: "64px",
      },
    },
  },
  MuiPickersCalendar: {
    styleOverrides: {
      transitionContainer: {
        marginTop: "6px",
      },
    },
  },
  MuiPickersCalendarHeader: {
    styleOverrides: {
      iconButton: {
        backgroundColor: "transparent",
        "& > *": {
          backgroundColor: "transparent",
        },
      },
      switchHeader: {
        marginTop: "2px",
        marginBottom: "4px",
      },
    },
  },
  MuiPickersClock: {
    styleOverrides: {
      container: {
        margin: `32px 0 4px`,
      },
    },
  },
  MuiPickersClockNumber: {
    styleOverrides: {
      clockNumber: {
        left: `calc(50% - 16px)`,
        width: "32px",
        height: "32px",
      },
    },
  },
  MuiPickerDTHeader: {
    styleOverrides: {
      dateHeader: {
        "& h4": {
          fontSize: "2.125rem",
          fontWeight: 400,
        },
      },
      timeHeader: {
        "& h3": {
          fontSize: "3rem",
          fontWeight: 400,
        },
      },
    },
  },
  MuiPickersTimePicker: {
    styleOverrides: {
      hourMinuteLabel: {
        "& h2": {
          fontSize: "3.75rem",
          fontWeight: 300,
        },
      },
    },
  },
  MuiPickersToolbar: {
    styleOverrides: {
      toolbar: {
        "& h4": {
          fontSize: "2.125rem",
          fontWeight: 400,
        },
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: "6px",
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: "6px",
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#2196f3",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#1a3a5c",
          borderWidth: "1px",
        },
      },
      notchedOutline: {
        borderColor: "#e0e0e0",
      },
      input: {
        padding: "10px 14px",
      },
    },
  },
  MuiTextField: {
    defaultProps: {
      variant: "outlined",
      size: "small",
    },
    styleOverrides: {
      root: {
        "& .MuiInputBase-root": {
          borderRadius: "6px",
        },
      },
    },
  },
  MuiSelect: {
    defaultProps: {
      variant: "outlined",
      size: "small",
    },
    styleOverrides: {
      outlined: {
        padding: "8px 14px",
      },
    },
  },
  MuiMenu: {
    styleOverrides: {
      paper: {
        borderRadius: "6px",
        boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
        border: "1px solid #e9ecef",
        marginTop: "4px",
      },
      list: {
        padding: "4px 0",
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        padding: "8px 16px",
        fontSize: "0.875rem",
        "&:hover": {
          backgroundColor: "rgba(26, 58, 92, 0.06)",
        },
        "&.Mui-selected": {
          backgroundColor: "rgba(33, 150, 243, 0.12)",
          "&:hover": {
            backgroundColor: "rgba(33, 150, 243, 0.18)",
          },
        },
      },
    },
  },
};

export default components;
